import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { ColumnLayout } from "../components/Layout/ColumnLayout";
import { GratuitiesFilter } from "../components/Reports/Gratuities/GratuitiesFilter";
import { GratuitiesTable } from "../components/Reports/Gratuities/GratuitiesTable";
import { Page } from "./Page";

export const GratuityReportPage = () => {
    return (
        <Page title="Gratuity Report">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Reports</Breadcrumb.Item>
                        <Breadcrumb.Item>Gratuities</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <GratuitiesFilter />

                <ColumnLayout.Fill>
                    <div className="px-6 pt-3 pb-20">
                        <GratuitiesTable />
                    </div>
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
